// Sample tenders data - replace with actual tenders from backend/API
export const tendersData = [
  {
    id: 1,
    tenderNo: "KWCL/T/001/2026",
    title: "PREQUALIFICATION DOCUMENT 2026-2028 FY",
    category: "Services",
    publishDate: "2026-04-22",
    closingDate: "2026-05-06",
    closingTime: "10:00 AM",
    documentUrl: "/PREQUALIFICATION DOCUMENT 2026-2028 FY.docx",
    contactEmail: "tenders@kikuyuwater.co.ke",
    contactPhone: "+254 728 578 098",
    status: "Open"
  },
  {
    id: 2,
    tenderNo: "KWCL/T/002/2026",
    title: "LIMURU WATER & SEWERAGE COMPANY",
    category: "Works",
    publishDate: "2026-04-22",
    closingDate: "2026-05-22",
    closingTime: "10:00 AM",
    documentUrl: "/LIMURU WATER & SEWERAGE COMPANY.pdf",
    contactEmail: "tenders@kikuyuwater.co.ke",
    contactPhone: "+254 728 578 098",
    status: "Open"
  }
];

export default tendersData;
